// Only compare percentages: fixed currency rewards and discounts are not percentages.
export function cashbackPercent(offer) {
  const raw = offer.cashback_percent;
  if (typeof raw === "number" && Number.isFinite(raw) && raw >= 0) return raw;
  if (typeof raw === "string" && /^\d+(?:[.,]\d+)?%?$/.test(raw.trim())) return Number(raw.trim().replace("%", "").replace(",", "."));
  const text = offer.cashback_text || "";
  const matches = [...text.matchAll(/(\d+(?:[.,]\d+)?)\s*%/g)];
  return matches.length === 1 ? Number(matches[0][1].replace(",", ".")) : null;
}

export function orderBrands(items, order = "cashback_desc", cashbackOnly = false, kind = "all") {
  const byName = (a, b) => (a.name || a.title || "").localeCompare(b.name || b.title || "", "pt-BR", { sensitivity: "base" });
  return items.filter((item) => (!cashbackOnly || cashbackPercent(item) > 0) && (kind === "all" || rewardType(item) === kind)).sort((a, b) => {
    if (order === "name_asc") return byName(a, b);
    if (order === "name_desc") return byName(b, a);
    const left = cashbackPercent(a), right = cashbackPercent(b);
    if (left === null || right === null) return left === right ? byName(a, b) : left === null ? 1 : -1;
    return (order === "cashback_asc" ? left - right : right - left) || byName(a, b);
  });
}

// Read sequentially to preserve provider session rotation. Never show a partial
// category as a globally sorted result if a later page fails or repeats.
export async function readCategory(readPage, signal) {
  const items = new Map();
  for (let page = 1; page <= 100; page += 1) {
    if (signal.aborted) throw new Error("Consulta cancelada");
    const { data } = await readPage(page);
    if (data.needs_cpf) return { data };
    const rows = data.items || data.offers || [];
    const before = items.size;
    rows.forEach((item) => items.set(item.id, item));
    if (!rows.length || !data.has_more) return { data: { items: [...items.values()], has_more: false } };
    if (items.size === before) throw new Error("Paginação da categoria repetida");
  }
  throw new Error("Categoria excedeu o limite de páginas");
}

export function rewardType(offer) {
  if (cashbackPercent(offer) !== null) return "percent";
  if (/R\$\s*[\d.,]+/i.test(offer.cashback_text || "")) return "fixed";
  if (offer.discount_text && !offer.cashback_text) return "discount";
  return "unknown";
}
